import styled, { css } from 'styled-components';
import { textblocks } from 'seal-ui-components';
import { getBaseTheme } from '@Themes';
import { theme } from '@Themes/themeOverriderFabric';

const { blueHighlight } = theme.palette;
const { Heading4, Text } = textblocks;
const { texts, spaces, colors } = getBaseTheme();

export const NotFoundContainer = styled(Text)`
    color: red;
    ${texts.sizes.s};
`;

export const AllGroupsTexts = styled(Heading4)({
    // marginBottom: spaces.default.s,
    padding: spaces.default.s
});

export const TitleTreeWrapper = styled.div({
    padding: `${spaces.default.s} ${spaces.default.s} 0rem ${spaces.default.s}`,
    height: '100%'
});

export const InBodyTitle = styled(Text)`
    margin-left: 0;
    ${texts.sizes.s};
`;

export default css`
    flex-grow: 1;
    width: 100%;
    height: 100%;

    background-color: ${colors.area.default.complementaryBackgroundColor};

    .spinner-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }

    .clause-tree {
        height: 100%;

        div[class*='TreeList__StyledTreeList'] {
            background-color: inherit;
            padding: ${spaces.default.s};
        }

        .TreeItemBase__row > div.TreeItemBase > .TreeItemBase__checkbox {
            display: none;
        }

        .TreeItemBase__row > div.TreeItemBase.highlighted {
            background-color: ${colors.control.disabled.complementaryBackgroundColor};
            &:hover {
                background-color: ${colors.control.hover.complementaryForegroundColor};
            }
        }

        .ToggleButtonBase__button {
            &:hover {
                background-color: ${colors.control.hover.complementaryForegroundColor};
            }
        }

        .TreeItemBase {
            &:hover:not(.disabled) {
                background-color: ${colors.control.hover.complementaryForegroundColor} !important;
            }
        }

        &__text {
            text-overflow: ellipsis;
            overflow: hidden;

            &:focus {
                outline-style: none;
            }
        }

        &__group-name-tooltip {
            white-space: pre-line;
            width: 75%;
        }

        span {
            font-size: ${texts.sizes.s.fontSize};
        }
    }

    .description-tooltip {
        width: 75%;
    }

    .ms-Dialog-main {
        position: relative;
    }

    .ms-Dialog-title {
        padding: 0;
    }

    .ms-Dialog-inner {
        padding: 0 ${spaces.default.s} ${spaces.default.xl} ${spaces.default.s};
    }

    .clause-modal {
        ${texts.sizes.s};
        position: static;

        ol {
            margin: 0;
            padding-left: ${spaces.default.s};

            li + li {
                margin-top: ${spaces.default.xxs};
            }
        }

        &__header {
            font-weight: 700;
            padding: ${spaces.default.xs} 0;
        }

        &__clause {
            cursor: pointer;
            white-space: pre-line;

            &:hover {
                background-color: ${colors.control.hover.complementaryForegroundColor};
            }

            &.selected {
                background-color: ${blueHighlight};
            }
        }

        &__action-buttons {
            background-color: #fff;
            box-shadow: 0 0 2px 0 rgba(119, 107, 107, 0.5);
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            display: flex;
            justify-content: space-between;
            padding: ${spaces.inset.xs};

            button {
                flex-basis: 8rem;
                &:focus {
                    outline: none;
                }
            }
        }
    }
`;
